import { render, staticRenderFns } from "./Piutang.vue?vue&type=template&id=7a82ff4c"
import script from "./Piutang.vue?vue&type=script&lang=js"
export * from "./Piutang.vue?vue&type=script&lang=js"
import style0 from "./Piutang.vue?vue&type=style&index=0&id=7a82ff4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports